import React, {useEffect} from 'react'
import {useLocation} from 'react-router'
import {AsideMenuMain} from './AsideMenuMain'
import {DrawerComponent, ToggleComponent} from '../../../assets/ts/components'

type Props = {
  asideMenuCSSClasses: string[]
}

const AsideMenu: React.FC<Props> = ({asideMenuCSSClasses}) => {
  const {pathname} = useLocation()

  useEffect(() => {
    const timer = setTimeout(() => {
      DrawerComponent.reinitialization()
      ToggleComponent.reinitialization()
    }, 50)
    return () => clearTimeout(timer)
  }, [pathname])

  return (
    <div
      id='kt_aside_menu_wrapper'
      className='w-100'
    >
      <div
        id='kt_aside_navigation'
        data-kt-menu='true'
        className='menu menu-column'
      >
        <AsideMenuMain />
      </div>
    </div>
  )
}

export {AsideMenu}
